import {Component, OnInit, ViewEncapsulation} from '@angular/core';

import {
    trigger,
    state,
    style,
    animate,
    transition
} from '@angular/animations';
import {DatabaseService} from '../database.service';


declare var jQuery: any;
var name_entidad_gestion = "experience";
@Component({
    selector: 'app-experience',
    templateUrl: './experience.component.html',
    styleUrls: ['./experience.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('fadeAndZoom', [
            state('inactive', style({
                opacity: 0,
                transform: 'scale(0.8)'
            })),
            state('active', style({
                opacity: 1,
                transform: 'scale(1)'
            })),
            transition('inactive => active', animate('100ms ease-in')),
            transition('active => inactive', animate('100ms ease-out'))
        ])
    ]
})



export class ExperienceComponent implements OnInit {


    constructor(
        private database: DatabaseService
    ) {}


    ngOnInit() {
        console.log(name_entidad_gestion + " INIT");
    }


}



// WEBPACK FOOTER //
// ./src/app/experience/experience.component.ts